module.exports = __webpack_public_path__ + "static/media/logo.8bd53e61.png";